module.exports = __webpack_public_path__ + "media/images/icon_arrow_next-3f06621614f17230c8da86b8df277ef3.png";